import { View, ViewModel } from "binder"
import { MainWindowViewModel } from "./mainWindow-viewModel"

export class MainWindowView extends View<MainWindowViewModel>{
    GetViewUniqueId(): string {
        return "V-6406915A-002F-4917-BD71-B67121EC6C4F"
    }
    loadHtml(): string {
        let element = require('./mainWindow.html').default;
        let style = require('./mainWindow.less');
        return element;
    }
    constructor() {
       super();
    }
    public set content(v: ViewModel) { this._content = v; } public get content(): ViewModel { return this._content;} private _content: ViewModel;
    public set stableBackground(v: string) { this._stableBackground = v; } public get stableBackground(): string { return this._stableBackground;} private _stableBackground: string;
    public set transitionBackground(v: string) { this._transitionBackground = v; } public get transitionBackground(): string { return this._transitionBackground;} private _transitionBackground: string;
    public set transitioning(v: boolean) { this._transitioning = v; } public get transitioning(): boolean { return this._transitioning;} private _transitioning: boolean;


}
